import { declareString } from "@1js/localization";

export const FilterLabel = declareString("promptLibrary.savedPromptsFilter", {
  text: "Filter",
  comment:
    "Placeholder label used on the saved Copilot prompts filter component",
});

export const AllLabel = declareString("promptLibrary.savedPromptsAll", {
  text: "All",
  comment:
    "Label used on the saved prompts filter component to show all Copilot prompts",
});

export const MeLabel = declareString("promptLibrary.savedPromptsMe", {
  text: "Me",
  comment:
    "Label used on the saved prompts filter component to show all user-authored Copilot prompts",
});

export const MicrosoftLabel = declareString(
  "promptLibrary.savedPromptsMicrosoft",
  {
    text: "Microsoft",
    comment:
      "Label used on the saved prompts filter component to show all Microsoft-authored Copilot prompts {Locked}",
  }
);

export const OthersLabel = declareString("promptLibrary.savedPromptsOthers", {
  text: "Others",
  comment:
    "Label used on the saved prompts filter component to show all Copilot prompts created by others",
});

export const CreatedByMeLabel = declareString(
  "promptLibrary.savedPromptsCreatedByMe",
  {
    text: "Created by Me",
    comment:
      "Label used on the saved prompts filter component to show all user-authored Copilot prompts",
  }
);

export const CreatedByMicrosoftLabel = declareString(
  "promptLibrary.savedPromptsCreatedByMicrosoft",
  {
    text: "Created by Microsoft",
    comment:
      "Label used on the saved prompts filter component to show all Microsoft-authored Copilot prompts",
  }
);

export const CreatedByOthersLabel = declareString(
  "promptLibrary.savedPromptsCreatedByOthers",
  {
    text: "Created by others",
    comment:
      "Label used on the saved prompts filter component to show all Copilot prompts created by others",
  }
);

export const CreatedByAllLabel = declareString(
  "promptLibrary.savedPromptsCreatedByAll",
  {
    text: "Created by all",
    comment:
      "Label used on the saved prompts filter component to show all Copilot prompts created by all",
  }
);
